import { render } from "./blogDetailBannerComponent.vue?vue&type=template&id=4f04a8e9&scoped=true"
import script from "./blogDetailBannerComponent.vue?vue&type=script&lang=js"
export * from "./blogDetailBannerComponent.vue?vue&type=script&lang=js"

import "./blogDetailBannerComponent.vue?vue&type=style&index=0&id=4f04a8e9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f04a8e9"]])

export default __exports__